import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { TricolorStripe } from '../components/TricolorStripe';
import { teamList } from '../teamData';

export default function TeamsPage() {
  const { lang } = useLanguage();
  const copy = lang === 'fr'
    ? { title: 'Clubs Que Nous Habillons', sub: 'Les clubs et associations que nous équipons, saison après saison.', season: 'Saison', view: 'Voir le kit' }
    : { title: 'Clubs We Dress', sub: 'The clubs and associations we outfit, season after season.', season: 'Season', view: 'View the kit' };

  return (
    <div className="min-h-screen bg-[#0D0D0D]" data-testid="teams-page">
      <section className="relative pt-40 pb-16 text-center px-6">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-bebas text-5xl md:text-6xl lg:text-7xl text-white tracking-tight"
        >
          {copy.title}
        </motion.h1>
        <p className="font-dm text-base text-white/70 mt-4 max-w-2xl mx-auto">{copy.sub}</p>
      </section>

      <TricolorStripe />

      <section className="py-16 md:py-24 bg-[#FAFAFA]">
        <div className="max-w-6xl mx-auto px-6 md:px-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamList.map((team, i) => (
            <motion.div
              key={team.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <Link
                to={`/clubs/${team.slug}`}
                className="group block bg-white border border-[#E8E8E8] hover:border-transparent hover:shadow-2xl transition-all duration-300 p-8 text-center"
                data-testid={`team-card-${team.slug}`}
              >
                <div className="h-40 flex items-center justify-center">
                  <img src={team.logo} alt={team.name} className="max-h-36 w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
                </div>
                <h2 className="font-bebas text-2xl text-[#0D0D0D] tracking-wide mt-6">{team.name}</h2>
                <p className="font-dm text-xs uppercase tracking-[3px] text-[#6B6B6B] mt-1">
                  {copy.season} {team.season}{team.founded ? ` · Est. ${team.founded}` : ''}
                </p>
                <span className="inline-flex items-center gap-2 font-dm text-xs uppercase tracking-wider mt-5 text-[#CE2B37]">
                  {copy.view} <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
